import { render, staticRenderFns } from "./topNavBar.vue?vue&type=template&id=045c17d3&scoped=true"
import script from "./topNavBar.vue?vue&type=script&lang=js"
export * from "./topNavBar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "045c17d3",
  null
  
)

export default component.exports